import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, Col, Row, Container } from 'react-bootstrap';
import { Link, useParams, Navigate } from 'react-router-dom';
import CargosService from '../../../../../services/cargos';
import '../../../../../styles/botao.scss'

const Cargo = () => {
    let { id } = useParams()
    const [cargo, setCargo] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [redirect, setRedirect] = useState(false);

    async function fetchCargo(id) {
        const response = await CargosService.cargoEdit(id);
        setCargo(response.data["cargo"]);
    }

    useEffect(() => {
        fetchCargo(id);
    }, [id]);

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const carg = await CargosService.editar(id, {
                cargo: cargo
            })
            if (carg.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }
    if (sucesso && !redirect) {
        setTimeout(() => {
            setRedirect(true);
        }, 3000); // 3 segundos
    }

    // Quando redirect virar true → redireciona
    if (redirect) {
        return <Navigate to="/rh/cargos/listar" />;
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Row xs={1} lg={2}>
                        <Form onSubmit={HandleSubmit} >
                            <Row xs={1} lg={2}>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="cargo">
                                        <Form.Label>Cargo</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="cargo"
                                            value={cargo}
                                            onChange={e => setCargo(e.target.value)} />
                                    </Form.Group>
                                </Col>

                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={3}>
                                    <Button variant="success" className="alinha-botao" type="submit">
                                        Salvar
                                    </Button>
                                </Col>
                            </Row>
                        </Form >
                    </Row>
                    <br />
                    <Link to={'/rh/cargos/listar'}>
                        <Button variant="danger" type="button">
                            Cancelar
                        </Button>
                    </Link>
                </Container>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Alert variant='success'>
                        Cargo alterado com sucesso!<br />
                        Redirecionando em 3 segundos...
                    </Alert>
                </Container>
            </Fragment>
        )
    }
}

export default Cargo;